/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * id + name only — value is fetched on demand via /api/auxiliary_metric_results/{id}/.
 * @export
 * @interface AuxiliaryMetricResultStub
 */
export interface AuxiliaryMetricResultStub {
  /**
   *
   * @type {number}
   * @memberof AuxiliaryMetricResultStub
   */
  readonly id: number;
  /**
   *
   * @type {string}
   * @memberof AuxiliaryMetricResultStub
   */
  name: string;
}

/**
 * Check if a given object implements the AuxiliaryMetricResultStub interface.
 */
export function instanceOfAuxiliaryMetricResultStub(value: object): value is AuxiliaryMetricResultStub {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('name' in value) || value['name'] === undefined) return false;
  return true;
}

export function AuxiliaryMetricResultStubFromJSON(json: any): AuxiliaryMetricResultStub {
  return AuxiliaryMetricResultStubFromJSONTyped(json, false);
}

export function AuxiliaryMetricResultStubFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AuxiliaryMetricResultStub {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    name: json['name'],
  };
}

export function AuxiliaryMetricResultStubToJSON(value?: Omit<AuxiliaryMetricResultStub, 'id'> | null): any {
  if (value == null) {
    return value;
  }
  return {
    name: value['name'],
  };
}
